import React from "react";
import PropTypes from "prop-types";
import Text from "../Text/Text";
import Progress from "../Progress/index";
import useBreakpoints from "../hooks/useBreakpoints";
import DimensionIcon from "../DimensionIcon";
import styles from "./QuestionHeader.module.scss";

/** Contains the dimension, sub-dimension, count & progress */
function QuestionHeader(props) {
  const { currentQuestion, questions, progress } = props;
  const questionNumber = questions.findIndex(
    (q) => q.id === currentQuestion.id
  );

  const { active: activeBreakpoint } = useBreakpoints();
  return (
    <Container>
      <Wrapper>
        <DimensionDetails>
          <Text
            variant={activeBreakpoint === "sm" ? "subheading" : "h4"}
            weight="bold"
            className={styles.dimension}
          >
            <DimensionIcon dimension={currentQuestion.dimension} />
            {currentQuestion.dimension}
          </Text>
          <Text
            variant="bodyRegular"
            weight="medium"
            className={styles.sub_dimension}
          >
            {currentQuestion.subDimension}
          </Text>
        </DimensionDetails>
        <Text
          variant={activeBreakpoint === "sm" ? "h4" : "h2"}
          weight="regular"
          className={styles.count}
        >
          {`${questionNumber + 1} of ${questions.length}`}
        </Text>
      </Wrapper>
      <Progress progress={progress} />
    </Container>
  );
}

/** Wraps all of the content of the header */
function Container({ children }) {
  return <div className={styles.container}>{children}</div>;
}

function DimensionDetails({ children }) {
  return <div className={styles.dimension_details}>{children}</div>;
}

/** Wraps content in the header so they can be grouped and justified */
function Wrapper({ children }) {
  return <div className={styles.wrapper}>{children}</div>;
}

Container.propTypes = {
  children: PropTypes.node,
};

DimensionDetails.propTypes = {
  children: PropTypes.node,
};

Wrapper.propTypes = {
  children: PropTypes.node,
};

export default QuestionHeader;

QuestionHeader.propTypes = {
  currentQuestion: PropTypes.shape({
    answer: PropTypes.string,
    dimension: PropTypes.string,
    id: PropTypes.number,
    question: PropTypes.string,
    subDimension: PropTypes.string,
  }),
  progress: PropTypes.number,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.string,
      dimension: PropTypes.string,
      id: PropTypes.number,
      question: PropTypes.string,
      subDimension: PropTypes.string,
    })
  ),
};
